import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourerIssues`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerIssues/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerIssues/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function add (labourerIssue) {
    const payload = jsona.serialize({
        stuff: labourerIssue,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/labourerIssues`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (labourerIssue) {
    const payload = jsona.serialize({
        stuff: labourerIssue,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/labourerIssues/${labourerIssue.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/labourerIssues/${id}`, options);
}

function getCategories() {
    return axios.get(url + '/issues/categories')
        .then(function(response) {
            return response.data;
        });
}

function getStatuses() {
    return axios.get(url + '/issues/statuses')
        .then(function(response) {
            return response.data;
        });
}

function getPriorities() {
    return axios.get(url + '/issues/priorities')
        .then(function(response) {
            return response.data;
        });
}

function getIssues(labourerId, filters) {
    var options = {
        params: filters || {},
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(url + '/labourers/' + labourerId + '/issues', options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data.data),
                stats: response.data.stats,
                categories: response.data.categories
            };
        });
}

function getIssue(labourerId, issueId) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(url + '/labourers/' + labourerId + '/issues/' + issueId, options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data.data)
            };
        });
}

function createIssue(labourerId, data) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(url + '/labourers/' + labourerId + '/issues', data, options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data.data)
            };
        });
}

function updateIssue(labourerId, issueId, data) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.put(url + '/labourers/' + labourerId + '/issues/' + issueId, data, options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data.data)
            };
        });
}

function resolveIssue(labourerId, issueId, comments) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(url + '/labourers/' + labourerId + '/issues/' + issueId + '/resolve', { comments: comments }, options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data.data)
            };
        });
}

function closeIssue(labourerId, issueId, comments) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(url + '/labourers/' + labourerId + '/issues/' + issueId + '/close', { comments: comments }, options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data.data)
            };
        });
}

function reopenIssue(labourerId, issueId, comments) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(url + '/labourers/' + labourerId + '/issues/' + issueId + '/reopen', { comments: comments }, options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data.data)
            };
        });
}

function deleteIssue(labourerId, issueId) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(url + '/labourers/' + labourerId + '/issues/' + issueId, options)
        .then(function(response) {
            return response.data;
        });
}

function getStats(labourerId) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(url + '/labourers/' + labourerId + '/issues/stats', options)
        .then(function(response) {
            return response.data;
        });
}

export default {
    list:list,
    get:get,
    show:show,
    add:add,
    update:update,
    destroy:destroy,
    getCategories: getCategories,
    getStatuses: getStatuses,
    getPriorities: getPriorities,
    getIssues: getIssues,
    getIssue: getIssue,
    createIssue: createIssue,
    updateIssue: updateIssue,
    resolveIssue: resolveIssue,
    closeIssue: closeIssue,
    reopenIssue: reopenIssue,
    deleteIssue: deleteIssue,
    getStats: getStats
};

